<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>工讀生清單</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>工讀生管理</span></li>
          <li><span>工讀生清單</span></li>
          <li><span>工讀記錄表</span></li>
        </ol>
      </div>
    </header>

    <!-- start: page -->
    <div id="tabs-02" class="row">
      <div id="tabs-04" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <table class="table table-no-more table-bordered table-striped mb-none">
                <thead>
                  <tr>
                    <th class="text-center" width="3%">筆數</th>
                    <th class="text-center" width="5%">類型</th>
                    <th class="text-center" width="10%">申請單位</th>
                    <th class="text-center" width="5%">姓名</th>
                    <th class="text-center" width="5%">學號</th>
                    <th class="text-center" width="15%">排班時間</th>
                    <th class="text-center" width="5%">請假</th>
                    <th class="text-center" width="5%">工作記錄</th>
                    <th class="text-center" width="5%">填寫狀態</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in list" :key="index">
                    <td data-title="筆數" class="text-center">{{index + 1}}</td>
                    <td data-title="類型" class="text-center">{{item.workstudyType}}</td>
                    <td data-title="申請單位" class="text-center">{{item.deptName}}</td>
                    <td data-title="姓名" class="text-center">{{item.studentName}}</td>
                    <td data-title="學號" class="text-center">{{item.studentId}}</td>
                    <td data-title="排班時間" class="text-center">{{item.scheduleTime}}</td>
                    <td data-title="請假" class="text-center" style="color: #C00;" v-if="item.isLeave==true">已請假</td>
                    <td data-title="請假" class="text-center" style="color: #C00;" v-else-if="item.isLeave==false">審核中</td>
                    <td data-title="請假" class="text-center" v-else>
                      <router-link :to="'/student/leave/' + item.id">請假單</router-link>
                    </td>
                    <td data-title="工作記錄" class="text-center">
                      <router-link :to="'/student/work-record/' + item.id" v-if="(!item.isLeaveAll && nowDate() > new Date(item.scheduleTime.split(' ')[0])) || item.isOpenWorkRecord" >工作記錄</router-link>
                    </td>
                    <td data-title="填寫狀態" class="text-center" style="font-weight: bold;" v-if="item.isLeaveAll">已請假</td>
                    <td data-title="填寫狀態" class="text-center" style="color: #270;" v-else-if="item.isWorkRecord">已填</td>
                    <td data-title="填寫狀態" class="text-center" style="color: #C00;" v-else>未填</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      list: []
    };
  },
  computed: {
    date() {
      return this.$route.params.date;
    }
  },
  mounted() {
    this.$http
      .get("/api/workstudyStudent/date-list", { params: { date: this.date } })
      .then(a => {
        this.list = a.body;
      });
  }
};
</script>

<style>
</style>